import { Column } from '@lightningjs/ui-components';
import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

// Components
import VODInfo from './components/VODInfo';
import PlayButton from './components/PlayButton';
import SubscriptionModal from './components/SubscriptionModal';
import PaidTitleModal from './components/UpgradeModal';
export default class Home extends Lightning.Component {
  static _template() {
    return {
      ...super._template(),
      PaidTitleModal: {
        w: 1920,
        h: 1080,
        zIndex: 200,
        type: PaidTitleModal,
        color: Colors('#000000').get(),
        rect: true,
        visible: false,
      },
      SubscriptionModal: {
        type: SubscriptionModal,
        visible: false,
      },
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          zIndex: 99,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        w: 1720,
        h: 500,
        x: 200,
        y: 0,
        type: VODInfo,
      },
      Wrapper: {
        w: 1770,
        h: 600,
        x: 150,
        y: 660,
        clipping: true,
        Column: {
          x: 51,
          type: Column,
          collision: true,
          shouldSmooth: true,
        },
      },
      Border: {
        w: 205,
        h: 70,
        x: 197,
        y: 457,
        type: PlayButton,
        collision: true,
        name: 'PlayBtn',
        visible: true,
        PlayButton: {
          w: 205,
          h: 70,
          x: 3,
          y: 3,
          rect: true,
          visible: true,
          color: Colors('#292929').get(),
          shader: { type: Lightning.shaders.RoundedRectangle, radius: 16 },
          Svg: {
            x: 30,
            y: 22,
            texture: lng.Tools.getSvgTexture(
              Utils.asset('images/movie-info-icons/resume.svg'),
              23,
              26
            ),
          },
          Text: {
            x: 80,
            y: 12,
            text: {
              text: 'Play',
              fontSize: 36,
              lineHeight: 40,
            },
          },
        },
      },
      BorderMoreInfo: {
        x: 442,
        y: 457,
        w: 205,
        h: 70,
        name: 'MoreInfoBtn',
        collision: true,
        type: PlayButton,
        visible: true,
        MoreInfo: {
          x: 3,
          y: 3,
          w: 205,
          h: 70,
          rect: true,
          visible: true,
          color: Colors('#292929').get(),
          shader: { type: Lightning.shaders.RoundedRectangle, radius: 16 },
          Text: {
            x: 27,
            y: 12,
            text: {
              text: 'More info',
              fontSize: 36,
              lineHeight: 40,
            },
          },
        },
      },
      FilterButton: {
        w: 600,
        h: 70,
        x: 197,
        y: 560,
        rect: true,
        collision: true,
        name: 'FilterButton',
        type: PlayButton,
        color: Colors('#000000').alpha(0.5).get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 12 },
        ButtonWrapper: {
          w: 600,
          flex: {
            direction: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
          },
          flexItem: { margin: 10, maxWidth: 500 },
          Title: {
            y: 5,
            x: 20,
            text: {
              fontFace: 'OpenSans-Regular',
              fontSize: 26,
              textOverflow: 'ellipsis',
              wordWrapWidth: 500,
              maxLines: 1,
              wordWrap: false,
            },
          },
          Image: {
            x: -20,
            color: Colors('#fafafa').get(),
            texture: lng.Tools.getSvgTexture(Utils.asset('images/filter-icon.svg'), 50, 50),
          },
        },
      },
    };
  }
  get id() {
    return 'HomePage';
  }

  get _Column() {
    return this.tag('Wrapper.Column');
  }

  set heroId(val) {
    return (this._heroId = val);
  }

  set filter(val) {
    this._filter = val;
  }

  _handleLeft() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
    }
  }

  $changeVODInfo({
    title,
    description,
    category,
    duration,
    cover,
    rating,
    votes,
    contentRating,
    kind,
  }) {
    // Kreiramo debounced funkciju samo jednom
    if (!this._debouncedChangeVOD) {
      this._debouncedChangeVOD = this._debounce(
        ({ title, description, category, duration, cover, rating, votes, contentRating, kind }) => {
          const ratingText = `${rating}/10`;
          const categoryText = category && category.length > 0 ? category.join(' • ') : '';
          const parts = duration?.split(':').map((part) => parseInt(part));
          let seconds = 0;
          if (parts.length === 3) {
            seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
          } else if (parts.length === 2) {
            seconds = parts[0] * 60 + parts[1];
          }

          let hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
          let minutes =
            parts[parts.length - 2] !== undefined
              ? parts[parts.length - 2].toString().padStart(2, '0')
              : '00';
          let secondsPart = parts[parts.length - 1].toString().padStart(2, '0');
          const durationText =
            seconds >= 3600
              ? `${hours}:${minutes}:${secondsPart} | `
              : `${minutes}:${secondsPart} | `;

          // Resetujemo alpha za fade-in efekat
          const contentInfo = this.tag('Content.Info');
          contentInfo.alpha = 0;
          const contentCover = this.tag('Content.Cover');
          contentCover.alpha = 0;

          // Animiramo fade-in za Info i Cover
          contentInfo.patch({
            Title: { text: { text: title } },
            Informations: {
              visible: kind === 'collection' ? false : true,
              DurationAndIcon: {
                Svg: {
                  x: seconds > 3600 ? 130 : 90,
                  texture: lng.Tools.getSvgTexture(
                    Utils.asset('images/movie-info-icons/star.svg'),
                    20,
                    20
                  ),
                },
                text: { text: duration ? durationText : '00:00 |' },
              },
              Rating: {
                x: seconds > 3600 ? 165 : 125,
                text: { text: rating ? `IMDB ${ratingText}` : '' },
              },
              Votes: {
                x: seconds > 3600 ? 315 : 275,
                text: { text: votes ? `(${votes})` : 0 },
              },
              ContentRating: {
                x: seconds > 3600 ? 375 : 330,
                text: { text: `| (${contentRating})` },
              },
            },
            Category: {
              text: { text: categoryText },
            },
            Description: { text: { text: description } },
          });

          contentCover.patch({
            texture: { src: cover },
          });

          // FadeIn animacija za Content.Info
          contentInfo.setSmooth('alpha', 1, { duration: 0.5, delay: 0.1 });
          // FadeIn animacija za sliku (Cover)
          contentCover.setSmooth('alpha', 1, { duration: 0.5, delay: 0.1 });
        },
        500
      ); // Debounce delay od 300ms
    }

    // Zovemo debounced funkciju
    this._debouncedChangeVOD({
      title,
      description,
      category,
      duration,
      cover,
      rating,
      votes,
      contentRating,
      kind,
    });
  }

  _debounce(func, delay) {
    let debounced = (...args) => {
      if (debounced.timeout) {
        clearTimeout(debounced.timeout);
      }
      debounced.timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
    return debounced;
  }

  // Gubljenje Modala za subskripciju
  $hideModal() {
    (this.tag('SubscriptionModal').visible = false), this._setState('PlayBtn');
  }

  // Gubljenje Paid modala
  $hidePaidTitleModal() {
    this.tag('PaidTitleModal').visible = false;
    if (this.tag('Border').visible) {
      this._setState('PlayBtn');
    } else {
      this._setState('Items');
    }
  }

  _hideVODHero() {
    this.tag('Content.Cover').smooth = {
      x: 520,
      y: 0,
      w: 1200,
      h: 690,
    };
    this.tag('Border').visible = false;
    this.tag('BorderMoreInfo').visible = false;
    this.tag('FilterButton').visible = false;
    this.tag('Wrapper').smooth = { y: 560 };
  }

  _active() {
    if (!this._heroId) {
      this._setState('Items');
      this._hideVODHero();
    } else {
      this._setupHeroSection();
      let subscription = JSON.parse(localStorage.getItem('subscription'));
      let subscriptionConfirmed = JSON.parse(localStorage.getItem('subscriptionConfirmed'));
      if (subscription || subscriptionConfirmed) {
        this.tag('Content.Info').patch({
          x: 0,
        });
        this._setState('PlayBtn');
      } else {
        this.tag('SubscriptionModal').visible = true;
        this._setState('SubscriptionModal');
      }
    }
  }

  _setupHeroSection() {
    // const { data } = this._heroId;
    let data = this._heroId?.data;
    // Podesi vidljivost
    this._setVisibility(true);

    // Podesi z-index i sliku za omot
    this._setCoverImage(data.cover);

    // Računanje trajanja i kategorizacije
    const { durationText, seconds } = this._calculateDuration(data.duration);
    const ratingText = `${data.rating}/10`;
    const categoryText = data.category?.length ? data.category.join(' • ') : '';

    // Naslov
    this._setTitle(data.title);

    // Ikona trajanja
    this._setDurationIcon(seconds);

    // Informacije o trajanju, rejtingu i broju glasova
    this._setDurationAndRating(durationText, ratingText, data.votes, data.contentRating, seconds);

    // Kategorija i opis
    this._setCategoryAndDescription(categoryText, data.description);

    // Setovanje filter button-a na hero sekciji
    this._setFilterButton();
  }

  _setFilterButton() {
    if (this._filter.length > 0) {
      this.tag('Wrapper').smooth = { y: 660 };
      this.tag('FilterButton').visible = true;
      const combinedString = this._filter.join(' - ');
      this.tag('FilterButton.Title').smooth = {
        text: { text: `Filter: ${combinedString} `, textColor: Colors('#fafafa').get() },
      };
    } else {
      this.tag('Wrapper').smooth = { y: 560 };
      this.tag('FilterButton').visible = false;
    }
  }

  _setVisibility(visible) {
    this.tag('Content.Info.Informations').visible = visible;
    this.tag('Border').visible = visible;
    this.tag('BorderMoreInfo').visible = visible;
    this.tag('Content.Info').zIndex = 100;
  }

  _setCoverImage(cover) {
    this.tag('Content.Cover').patch({
      texture: {
        type: Lightning.textures.ImageTexture,
        src: cover,
        resizeMode: { type: 'contain', w: this.w, h: this.h },
      },
    });
    this.tag('Content.Cover').smooth = {
      x: 0,
      y: 0,
      w: 1720,
      h: 967.5,
    };
  }

  _calculateDuration(duration) {
    const parts = duration?.split(':').map((part) => parseInt(part)) || [];
    let seconds = 0;

    if (parts.length === 3) {
      seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) {
      seconds = parts[0] * 60 + parts[1];
    }

    const hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
    const minutes = parts[parts.length - 2]?.toString().padStart(2, '0') || '00';
    const secondsPart = parts[parts.length - 1]?.toString().padStart(2, '0') || '00';

    const durationText =
      seconds >= 3600 ? `${hours}:${minutes}:${secondsPart} | ` : `${minutes}:${secondsPart} | `;

    return { durationText, seconds };
  }

  _setTitle(title) {
    this.tag('Content.Info.Title').patch({
      text: { text: title },
    });
  }

  _setDurationIcon(seconds) {
    const iconX = seconds > 3600 ? 130 : 90;
    this.tag('Content.Info.Informations.DurationAndIcon').patch({
      Svg: {
        y: 3,
        w: 25,
        h: 25,
        x: iconX,
        texture: lng.Tools.getSvgTexture(Utils.asset('images/movie-info-icons/star.svg'), 20, 20),
      },
    });
  }

  _setDurationAndRating(durationText, ratingText, votes, contentRating, seconds) {
    const ratingX = seconds > 3600 ? 165 : 125;
    const votesX = seconds > 3600 ? 315 : 275;
    const contentRatingX = seconds > 3600 ? 375 : 330;

    this.tag('Content.Info.Informations.DurationAndIcon').patch({
      text: durationText || '-',
    });
    this.tag('Content.Info.Informations.Rating').patch({
      x: ratingX,
      text: { text: `IMDB ${ratingText}` || '/' },
    });
    this.tag('Content.Info.Informations.Votes').patch({
      x: votesX,
      text: { text: votes ? `(${votes})` : 0 },
    });
    this.tag('Content.Info.Informations.ContentRating').patch({
      x: contentRatingX,
      text: { text: `| (${contentRating})` },
    });
  }

  _setCategoryAndDescription(categoryText, description) {
    this.tag('Content.Info.Category').patch({
      text: { text: categoryText },
    });
    this.tag('Content.Info.Description').patch({
      text: { text: description },
    });
  }

  async $handleEnter() {
    let fp = this.application.focusPath;
    let isProtected = (fp && fp.length > 0 && fp[fp.length - 1])._isProtected;
    let activeTile = (fp && fp.length > 0 && fp[fp.length - 1].data) || {};
    if (activeTile && activeTile.kind) {
      switch (activeTile.kind) {
        case 'movie':
          if (isProtected) {
            this.tag('PaidTitleModal').visible = true;
            this._setState('PaidTitleModal');
          } else {
            Storage.set('video', { id: activeTile.id, watchList: 0 });
            Router.navigate(`movie/${activeTile.id}`);
          }
          break;
        case 'subseries':
          Router.navigate(`series/${activeTile.id}`);
          break;
        case 'collection':
          Router.navigate(`categories/${activeTile.id}`);
          break;
      }
      this.tag('Content.Info').smooth = {
        zIndex: 0,
      };
    } else {
      console.error('activeTile or its kind property is not available');
    }
  }

  $setState(state) {
    this._setState(state);
  }

  $unselectCurrentIndex() {
    let currentIndex = this._Column.selectedIndex;
    let rowIndex = this._Column.items[currentIndex].selectedIndex;
    this._Column.items[currentIndex].items[rowIndex]._unfocus();
  }

  $setFocus({ rowIndex, index }) {
    this._Column.scrollTo(rowIndex, 10);
    this._Column.items[rowIndex].scrollTo(index, 10);
    this.$setState('Items');
  }

  $scroll(event) {
    this._handleScroll(event);
  }

  _handleScroll = this._debounce((event) => {
    let currentIndex = this._Column.selectedIndex;
    let nextIndex = currentIndex + 1;
    let previousIndex = currentIndex - 1;

    if (event.deltaY > 0) {
      this._Column.scrollTo(nextIndex, 50);
    } else if (event.deltaY < 0) {
      this._Column.scrollTo(previousIndex, 50);
    }
  }, 200);

  static _states() {
    return [
      class SubscriptionModal extends this {
        _getFocused() {
          return this.tag('SubscriptionModal');
        }
      },
      class PaidTitleModal extends this {
        _getFocused() {
          return this.tag('PaidTitleModal');
        }
      },
      class PlayBtn extends this {
        _getFocused() {
          return this.tag('Border');
        }

        _focus() {
          this.tag('Content.Info').smooth = {
            x: 0,
          };
        }
        _enable() {
          this.tag('Content.Info').smooth = {
            x: 0,
          };
          this.tag('Content.Cover').smooth = {
            x: 0,
            y: 0,
            w: 1920, // Initial width
            h: 1080, // Initial height
          };
        }
        _handleDown() {
          if (this.tag('FilterButton').visible) {
            this._setState('FilterButton');
          } else {
            this._setState('Items');
          }
        }
        _handleRight() {
          this._setState('MoreInfoBtn');
        }

        _handleEnter() {
          let profileInfo = JSON.parse(localStorage.getItem('profileInfo'));
          let profileId = Storage.get('profileId');
          let defaultValue = Storage.get(`audiosubtitles-${profileId}`);
          localStorage.removeItem('VODList');
          if (this._heroId.data.kind === 'movie') {
            if (this._heroId.data.isProtected) {
              (this.tag('PaidTitleModal').visible = true), this._setState('PaidTitleModal');
              return;
            }
            let MovieID = this._heroId.data.id;
            let movieInfo = this._heroId.data;

            if (movieInfo.tvod == true) {
              Router.navigate('locked');
              return;
            }
            Storage.set('video', { id: MovieID, watchList: 0 });
            let subtitle;
            let audio;
            subtitle = 'none';
            let baseUrl = 'https://stream.livingscriptures.com/api/v4';
            let cleanUrl = movieInfo.languages.replace(baseUrl, '');
            audio = cleanUrl;
            if (audio != undefined) {
              Router.navigate('player', {
                kind: profileInfo?.autoplay ? 'movie' : 'all',
                subtitle: subtitle,
                videoUrl: audio,
                videoDuration: movieInfo.duration,
                introEndsAt: movieInfo.languages[defaultValue.audio]?.intro_ends_at,
                movieId: MovieID,
              });
            }
          } else {
            let MovieID = this._heroId.data.id;
            let movieInfo = this._heroId.data;
            if (movieInfo?.tvod) {
              return;
            }
            if (this._heroId.data.isProtected) {
              (this.tag('PaidTitleModal').visible = true), this._setState('PaidTitleModal');
              return;
            }
            let contentPreferences = Storage.get('content_preferences');
            let profileInfo = JSON.parse(localStorage.getItem('profileInfo'));
            let profileId = Storage.get('profileId');
            let subtitle;
            let audio;
            let defaultValue = Storage.get(`audiosubtitles-${profileId}`);
            subtitle = 'none';
            audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
            if (defaultValue) {
              if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
                audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
              }
              if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
                subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
              }
            }
            let movieConfiguration = contentPreferences?.find(
              (preference) =>
                preference.profileId === profileId && Number(preference.movieId) === MovieID
            );
            if (movieConfiguration) {
              subtitle = 'none';
              audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;

              if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
                subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
              }
              audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
            }
            Router.navigate('player', {
              kind: profileInfo?.autoplay ? 'series' : 'all',
              subtitle: subtitle,
              videoUrl: audio,
              videoDuration: movieInfo.duration,
              introEndsAt: movieInfo?.languages[defaultValue.audio]?.intro_ends_at,
              movieId: MovieID,
            });
          }
        }
        $pressedClick() {
          this._handleEnter();
        }
      },
      class MoreInfoBtn extends this {
        _getFocused() {
          return this.tag('BorderMoreInfo');
        }
        _handleEnter() {
          const movieKind = this._heroId?.data?.kind;
          let MovieID = this._heroId?.data?.id;
          let SerieId = this._heroId?.data?.idEntrySerie;

          switch (movieKind) {
            case 'movie':
              if (this._heroId.data.isProtected) {
                this.tag('PaidTitleModal').visible = true;
                this._setState('PaidTitleModal');
              } else {
                Storage.set('video', { id: MovieID, watchList: 0 });
                Router.navigate(`movie/${MovieID}`);
              }
              break;
            case 'subseries':
              Router.navigate(`series/${SerieId}`);
              break;
          }
        }
        $pressedClick() {
          this._handleEnter();
        }
        _handleLeft() {
          this._setState('PlayBtn');
        }
        _handleDown() {
          if (this.tag('FilterButton').visible) {
            this._setState('FilterButton');
          } else {
            this._setState('Items');
          }
        }
      },
      class FilterButton extends this {
        _getFocused() {
          return this.tag('FilterButton');
        }

        _handleEnter() {
          Router.navigate('settings/filters');
        }

        _handleUp() {
          this._setState('PlayBtn');
        }

        _handleDown() {
          this._setState('Items');
        }
      },
      class Items extends this {
        get _Column() {
          return this.tag('Wrapper.Column');
        }
        _getFocused() {
          this._hideVODHero();
          return this._Column;
        }

        _handleUp() {
          if (this._debouncedChangeVOD && this._debouncedChangeVOD.timeout) {
            clearTimeout(this._debouncedChangeVOD.timeout);
          }
          if (this._heroId) {
            this._setupHeroSection();
            this._setState('PlayBtn');
          }
        }
      },
    ];
  }
}
